// lib
import React from 'react';
import { Icon } from 'antd';

// container
import Detail from '../containers/Proceed/Detail'
import LoanApply from '../containers/Proceed/LoanApply'
import List from '../containers/Proceed/List'
import ApplyContract from "../containers/Proceed/ApplyContract";

export default {
  path: '/proceed',
  sidebar: {
    // TODO x-ray 更换icon
    icon: <Icon type="pie-chart" />,
    title: <span>收款管理</span>,
  },
  routes: [
    {
      path: '/detail',
      sidebar: {
        // TODO x-ray 确认是否需要hide
        hide: false,
        title: <span>收款记录详情</span>,
      },
      component: Detail,
    },
    {
      path: '/loanapply',
      sidebar: {
        hide: false,
        title: <span>提前收款确认页</span>,
      },
      component: LoanApply,
    },
    {
      path: '/contract',
      sidebar: {
        hide: false,
        title: <span>支用法人签约</span>,
      },
      component: ApplyContract,
    },
    {
      path: '/list',
      sidebar: {
        // TODO x-ray 确认是否需要hide
        hide: false,
        title: <span>列表页</span>,
      },
      component: List,
    },
  ]
};



// WEBPACK FOOTER //
// ./src/routes/proceed.jsx